export default __webpack_public_path__ + "static/media/6.1bbe0f42.jpeg";